import React from "react";
import PropTypes from "prop-types";
import { formatDate } from "utils/misc";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";

const ProductLineSelectionModal = ({
  productLines,
  patientHCPCHistory,
  onSelect,
  onClose
}) => {
  // Helper function matching the non-patient facing app
  const getMostRecentEligibleItem = productLine => {
    const itemsForProductLine = patientHCPCHistory?.filter(item => {
      return item.productLine === productLine && item.productType !== "Machine";
    });
    if (itemsForProductLine?.length === 0) return { isEligible: true };

    const sortedItems = itemsForProductLine.sort((a, b) => {
      const dateA = new Date(a.eligibilityDate);
      const dateB = new Date(b.eligibilityDate);
      return dateA - dateB;
    });

    const mostRecent = sortedItems[0];
    return mostRecent;
  };

  // Helper function to get eligibility status display matching the non-patient facing app
  const getEligibilityStatus = item => {
    if (!item || item.isEligible) {
      return {
        text: "✓ Currently Eligible",
        color: "#28a745",
        bgColor: "#e8f5e8",
        borderColor: "#28a745"
      };
    } else if (item.isSoonEligible) {
      return {
        text: "⏰ Eligible Soon",
        color: "#ffc107",
        bgColor: "#fff3cd",
        borderColor: "#ffc107"
      };
    } else {
      return {
        text: "⚠ Not Currently Eligible",
        color: "#dc3545",
        bgColor: "#ffe6e6",
        borderColor: "#dc3545"
      };
    }
  };

  return (
    <>
      <DialogTitle>Select Product Line</DialogTitle>
      <DialogContent>
        <div style={{ padding: "10px 0" }}>
          <p style={{ fontSize: 16, marginBottom: 20, textAlign: "center" }}>
            Choose the product line you would like to order.
          </p>
          {productLines.map((line, idx) => {
            let earliestEligibleItem = null;
            let eligibilityStatus = null;

            // If patientHCPCHistory is available, use new logic, otherwise fall back to old logic
            if (patientHCPCHistory && patientHCPCHistory.length > 0) {
              earliestEligibleItem = getMostRecentEligibleItem(line.text);
              eligibilityStatus = getEligibilityStatus(earliestEligibleItem);
            }
            console.log({ earliestEligibleItem })

            return (
              <div
                key={idx}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: 15,
                  padding: "15px",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  backgroundColor: earliestEligibleItem?.isEligible ? "#f0f8f0" : "#fff",
                  cursor: "pointer"
                }}
                onClick={() => onSelect(line)}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <div style={{ fontSize: 16, fontWeight: "bold", marginBottom: 5 }}>
                      {line.text}
                    </div>
                    {eligibilityStatus && (
                      <div
                        style={{
                          fontSize: "12px",
                          color: eligibilityStatus.color,
                          fontWeight: "bold",
                          padding: "4px 8px",
                          borderRadius: "4px",
                          backgroundColor: eligibilityStatus.bgColor,
                          border: `1px solid ${eligibilityStatus.borderColor}`,
                          display: "inline-block"
                        }}
                      >
                        {eligibilityStatus.text}
                      </div>
                    )}
                    {patientHCPCHistory && patientHCPCHistory.length > 0 && !earliestEligibleItem?.isEligible && (
                      <div style={{ marginTop: "8px", fontSize: 14 }}>
                        <strong>Eligibility Date:</strong>{" "}
                        <span
                          style={{
                            color: eligibilityStatus?.color || "black",
                            fontWeight: "bold"
                          }}
                        >
                          {formatDate(earliestEligibleItem?.eligibilityDate, "MM/DD/YYYY")}
                        </span>
                      </div>
                    )}
                    {(!patientHCPCHistory || patientHCPCHistory.length === 0) && (
                      <div style={{ fontSize: 14, color: "#666" }}>
                        Eligible on {formatDate(line.outreach_date, "MM/DD/YYYY")}
                      </div>
                    )}
                  </div>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onSelect(line);
                    }}
                  >
                    Select
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </>
  );
};

ProductLineSelectionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  productLines: PropTypes.array.isRequired,
  patientHCPCHistory: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ProductLineSelectionModal;
